// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__9FMYN","filesListContainer":"PosDisputesFiles_filesListContainer__390KE","filesButton":"PosDisputesFiles_filesButton__3sGJj"};